<template>
  <div>
    {{ value }}
  </div>
</template>

<script>
import TipoNotificacao from '@/enums/tipo-notificacao';

export default {
  props: {
    tipoNotificacao: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  created() {
    if (!this.tipoNotificacao) {
      return;
    }
    this.value = TipoNotificacao.keys[this.tipoNotificacao].description;
  },
};
</script>
